import { type FC, type ReactNode } from "react"

import LexicalViewer from "@forento/shared/components/LexicalViewer"

type Props = {
	thumbnailUrl?: string | null
	title: string
	tags?: { id: number; label: string }[]
	description?: string
	htmlDescription?: string
	callToAction: ReactNode
}
const Hero: FC<Props> = ({ thumbnailUrl, title, tags, description, htmlDescription, callToAction }) => (
	<div className="mb-8 flex flex-col flex-wrap items-center gap-4 bg-white p-6 py-16 shadow lg:flex-row lg:gap-10 lg:px-20">
		<div className="flex grow flex-col gap-4 lg:flex-row lg:items-center lg:gap-10">
			{thumbnailUrl && (
				<div className="max-h-sm lg:max-w-2xs flex w-full max-w-sm items-center justify-center lg:justify-start">
					<img alt="Product thumbnail" src={thumbnailUrl} className="max-h-full max-w-full" />
				</div>
			)}
			<div className="flex grow flex-col gap-4 lg:gap-6">
				<h2 className="font-quicksand text-xl font-bold">{title}</h2>
				{description && <p className="text-sm">{description}</p>}
				{htmlDescription && <LexicalViewer html={htmlDescription} className="shrink" />}
				{tags && tags.length > 0 && (
					<div className="flex flex-wrap gap-2 self-center lg:self-start">
						{tags.map(tag => (
							<div
								key={tag.id}
								className="bg-primary/10 text-primary inline-flex items-center rounded-full px-4 py-2 text-sm font-medium"
							>
								<span className="bg-primary/60 mr-1.5 h-1.5 w-1.5 rounded-full" />
								{tag.label}
							</div>
						))}
					</div>
				)}
			</div>
		</div>
		<div className="justify-end self-center">{callToAction}</div>
	</div>
)

export default Hero
